import {gsap} from "gsap";


const animationEnter = (container) => {
    // console.log("SingleProject animation ENTER !!");

    // Element à animer
    const body_el = document.body;
    const mask = container.querySelector("#project_image_mask");
    const color_mask = mask.dataset.projectcolor;

    gsap.set(container, {alpha:1})
    gsap.set("#primary_section", {alpha:0})
    gsap.set("#scrollToContentLink", {alpha:0, y:100})

    // Gsap timeline
    const tl = gsap.timeline({
        defaults : {
            duration: .5,
            ease: "power1.out",
        },
    });
    tl.to(body_el, {backgroundColor:color_mask, duration:.5})
    tl.to("#primary_section", {alpha:1, duration:.5})
    tl.to("#scrollToContentLink", {alpha:1, y:0,duration:.5})
    //tl.to(container, {alpha:1})


    //pour dev
    tl.timeScale( 1 );
    return tl;
}

export default animationEnter;
